import { render, staticRenderFns } from "./ThumbIcon.vue?vue&type=template&id=74920e3a"
import script from "./ThumbIcon.vue?vue&type=script&lang=js"
export * from "./ThumbIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports